new nc.promokit.Preloader({
    'game': 'lineage2',
    'youtube': [
        'https://youtu.be/Duspwgdf39g',
    ],
    'image': [
        '/promo/lineage2/history/2019/191106_unboxing/img/deathknight/cont-cave3-1.png',
        '/promo/lineage2/history/2019/191106_unboxing/img/deathknight/cont-cave3-2.png',
        '/promo/lineage2/history/2019/191106_unboxing/img/deathknight/bg-section3.jpg',
        '/promo/lineage2/history/2019/191106_unboxing/img/deathknight/bg-section1.jpg',
        '/promo/lineage2/history/2019/191106_unboxing/img/deathknight/bg-section2.jpg',
        '/promo/lineage2/history/2019/191106_unboxing/img/deathknight/cont-cave2-1.jpg',
        '/promo/lineage2/history/2019/191106_unboxing/img/deathknight/sword.png',
        '/promo/lineage2/history/2019/191106_unboxing/img/deathknight/layer-item.jpg',
        '/promo/lineage2/history/2019/191106_unboxing/img/deathknight/cont-cave1.png',
        '/promo/lineage2/history/2019/191106_unboxing/img/deathknight/cont-cave2-2.jpg',
        '/promo/lineage2/history/2019/191106_unboxing/img/deathknight/layer-raid2.jpg',
        '/promo/lineage2/history/2019/191106_unboxing/img/deathknight/layer-raid1.jpg',
        '/promo/lineage2/history/2019/191106_unboxing/img/deathknight/cont-sword3.png',
        '/promo/lineage2/history/2019/191106_unboxing/img/deathknight/cont-sword2.png',
        '/promo/lineage2/history/2019/191106_unboxing/img/deathknight/cont-info.png',
        '/promo/lineage2/history/2019/191106_unboxing/img/deathknight/tab-cave.png',
        '/promo/lineage2/history/2019/191106_unboxing/img/deathknight/tab-sword.png',
    ]
});

var Ptab = function(el) {
    var $el = $(el);
    $el.find('.p-tab-list__item').eq(0).addClass('p-tab-list__item--active');
    $el.find('.p-tab-cont__item').eq(0).addClass('p-tab-cont__item--active');
    $el.on('click','.p-tab-list__item', function () {
        var num = this.getAttribute('data-tab') - 1;
        $el.find('.p-tab-list__item').removeClass('p-tab-list__item--active');
        $el.find('.p-tab-cont__item').removeClass('p-tab-cont__item--active');
        $el.find('.p-tab-list__item').eq(num).addClass('p-tab-list__item--active');
        $el.find('.p-tab-cont__item').eq(num).addClass('p-tab-cont__item--active');
    });
};

$(document).on('preloadend', function() {
    $('body').TopBtn();
    $('.toggle-caution').Folding({open: true});

    new nc.promokit.remote({
        element:"#remoteMenu",
        margin:-100,
        top:920,
        fix:287,
        show:true,
        quick:true,
        cspeed:600
    });
    new Ptab("#cave");
    new Ptab("#sword");

    var slick_battlefield = $('#battlefield').slick({
        infinite: true,
        fade : true,
        dots: false,
        arrows: true
    });
    var slick_raid = $('#raid').slick({
        infinite: true,
        fade : true,
        dots: false,
        arrows: true
    });

    var player_weapon = new nc.promokit.Player({
        selector: '#player-effect1',
        videoId:'Duspwgdf39g',
        mute: true,
        loop: true
    });

    player_weapon.on('canplay',function () {
        player_weapon.play();
        $('.p-tab-list').removeClass('p-tab-list--unclickable');
    });

/*
    if($('.p-tab-list').hasClass('p-tab-list--unclickable')){
        $(this).find('.p-tab-list__item').on('click',function (e) {
            e.stopPropagation();
        })
    }

*/

    /*
        var play_filter = function(slide_num) {
            var player_num;
            switch (slide_num) {
                case 0 :
                    player_num = player_weapon;
                    break;
                case 1 :
                    player_num = player_effect2;
                    break;
                case 2 :
                    player_num = player_effect3;
                    break;
            }
            return player_num;
        };

        slick_weapon.on('beforeChange',function (event, slick, currentSlide, nextSlide) {
            play_filter(currentSlide).pause();
            play_filter(nextSlide).seek(1);
            play_filter(nextSlide).play();
        });
    */



    $('#sword').on('click','.p-tab-list__item', function () {
        var index = $('#sword .p-tab-list__item').index(this);
        if(index!==0){
            // var player_index = $('#weapon').find('.p-slider-list__item.slick-active').attr('data-slick-index');
            player_weapon.pause();
        } else {
/*
            var player_index = $('#weapon').find('.p-slider-list__item.slick-active').attr('data-slick-index');
            play_filter(Number(player_index)).seek(1);
            play_filter(Number(player_index)).play();
*/
            player_weapon.seek(1);
            player_weapon.play();
        }
    });
});


// WEBPACK FOOTER //
// ./src/js/deathknight.js